/* eslint-disable */
import * as React from "react";
import { dictionaryService } from "../../../dataFlow";
import { useParameter, useExport, useDictionary } from "../../../shared";
import { getCalendarParameterSelection } from "../utils/getCalendarParameterSelection";

export function useExportQuery(title: string, subtitle: string) {
  const exportBuilder = useExport();

  const [selectedCommodityId] = useParameter<number>("@selected_commodity_id");
  const [selectedUnitId] = useParameter<number>("@selected_unit_id");
  const [commodities] = useParameter<number>("@commodities");
  const [calendar] = useParameter<number[]>("@calendar");
  const [units] = useParameter<number>("@units");

  const [dictItems] = useDictionary(dictionaryService, "calendar-origin");

  React.useEffect(() => {
    if (calendar != null && dictItems) {
      const calendarParameterSelection = getCalendarParameterSelection(calendar, dictItems);

      exportBuilder.set("title", title);
      exportBuilder.set("subtitle", subtitle);
      exportBuilder.set("reportDefinition", {
        reportId: exportBuilder.reportId,
        name: { 9: title },
        parameters: {
          "@selected_commodity_id": selectedCommodityId,
          "@selected_unit_id": selectedUnitId,
          "@calendar": calendarParameterSelection,
          "@commodities": commodities,
          "@units": units,
        },
      });
    }
  }, [title, subtitle, exportBuilder, calendar, commodities, units, selectedCommodityId, selectedUnitId]);
}
